function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}
class TrackingConsent {
  constructor() {
    var __trackingConsent = undefined;
    Object.defineProperty(window.Shopify, "trackingConsent", {
      get: function () {
        return __trackingConsent || window.Shopify.customerPrivacy;
      },
      set(val) {
        __trackingConsent = val;
        var ok = val.getTrackingConsent();
        console.log("__trackingConsent set---->", ok);
        if (ok != "yes") {
          gtag("consent", "default", {
            ad_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
            analytics_storage: "denied",
          });
        }
      },
    });
    if (
      window.Shopify.trackingConsent &&
      window.Shopify.trackingConsent.getTrackingConsent
    ) {
      var ok = window.Shopify.trackingConsent.getTrackingConsent();
      if (ok != "yes") {
        gtag("consent", "default", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied",
        });
      }
    }

    document.body.addEventListener("click", function (event) {
      if (
        event.target.matches(
          "#shopify-pc__banner__btn-accept,#shopify-pc__prefs__header-accept"
        )
      ) {
        console.log("shopify accept");
        gtag("consent", "update", {
          ad_user_data: "granted",
          ad_personalization: "granted",
          ad_storage: "granted",
          analytics_storage: "granted",
        });
      }
    });

    document.body.addEventListener("click", function (event) {
      if (event.target.matches("#shopify-pc__banner__btn-manage-prefs")) {
        const marketing = document.querySelector(
          "#shopify-pc__prefs__marketing"
        );
        const marketingInput = marketing.querySelector("input");
        const marketingSvgs = marketing.querySelectorAll("svg");
        marketingInput.checked = true;
        marketingSvgs[0].style.display = "block";
        marketingSvgs[1].style.display = "none";

        const analytics = document.querySelector(
          "#shopify-pc__prefs__analytics"
        );
        const analyticsInput = analytics.querySelector("input");
        const analyticsSvgs = analytics.querySelectorAll("svg");
        analyticsInput.checked = true;
        analyticsSvgs[0].style.display = "block";
        analyticsSvgs[1].style.display = "none";

        const preferences = document.querySelector(
          "#shopify-pc__prefs__preferences"
        );
        const preferencesInput = preferences.querySelector("input");
        const preferencesSvgs = preferences.querySelectorAll("svg");
        preferencesInput.checked = true;
        preferencesSvgs[0].style.display = "block";
        preferencesSvgs[1].style.display = "none";
      }
    });

    document.body.addEventListener("click", function (event) {
      if (event.target.matches("#shopify-pc__prefs__header-save")) {
        console.log("shopify save");
        var data = {
          ad_user_data: "granted",
          ad_personalization: document.querySelector(
            "#shopify-pc__prefs__preferences-input"
          ).checked
            ? "granted"
            : "denied",
          ad_storage: document.querySelector(
            "#shopify-pc__prefs__marketing-input"
          ).checked
            ? "granted"
            : "denied",
          analytics_storage: document.querySelector(
            "#shopify-pc__prefs__analytics-input"
          ).checked
            ? "granted"
            : "denied",
        };
        console.log("shopify save", data);
        gtag("consent", "update", data);
      }
    });
  }
}
// 处理 FAQ 功能  /pages/order
function faqFunc() {
  // 设置FAQ标题颜色
  document.querySelectorAll(".click_title").forEach((element) => {
    if (element.textContent.trim() === "FAQ") {
      element.style.color = "#eb5148";
    }
  });
  document.querySelectorAll(".question_main").forEach((question) => {
    question.addEventListener("click", function (event) {
      const questionContent = event.target.closest(".question_content");
      if (questionContent) {
        const que = questionContent.querySelector(".question_que");
        if (que) {
          que.classList.toggle("active");
        }
      }
    });
  });
}
class FooterEvent {
  constructor() {
    const dom = document.querySelectorAll(".footer .footer__block--menu");

    dom.forEach((item) => {
      item.addEventListener("click", function (e) {
        const target = e.target;
        const _this = target.closest(".footer__block--menu");
        if (_this) {
          _this.querySelector(".link__ul").classList.toggle("active");
          const button = _this.querySelector(".plus-button");
          if (button) {
            button.innerText = button.innerText === "+" ? "-" : "+";
          }
        }
      });
    });
  }
}
function init() {
  new TrackingConsent();
  new FooterEvent();
  hdAdp();
  const first_flags = document.querySelector(".first_flags");
  const second_flags = document.querySelector(".second_flags");
  if (first_flags) {
    first_flags.addEventListener("click", function (e) {
      second_flags.classList.toggle("active");
    });
  }
  faqFunc();
  document.querySelectorAll(".r-goto").forEach((item) => {
    item.addEventListener("click", function (e) {
      const target = e.target;
      console.log(target, "target");

      const url = target.closest(".r-goto").dataset.target;
      // 跳转到 #plugin_features
      if (url) {
        const targetElement = document.querySelector("#" + url);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
  });
  document.querySelectorAll(".goto-link").forEach((item) => {
    item.addEventListener("click", function (e) {
      const target = e.target.closest(".goto-link");
      const gotoLink = target.dataset.gotoLink;
      if (gotoLink) {
        // 如果有 gotoLink 属性，跳转到指定链接
        window.location.href = gotoLink;
      }
    });
  });
  // 处理产品页的浮动筛选按钮
  document.addEventListener("click", function (event) {
    const target = event.target;
    if (target.classList.contains("facet-type")) {
      const dom = document.querySelector(".facet-floating-filter__button");
      if (dom) {
        dom.click();
      }
    }
  });
}

function ready(callback) {
  if (
    document.readyState === "interactive" ||
    document.readyState === "complete"
  ) {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}
ready(init);

function hdAdp() {
  if (!window.location.pathname.includes("/collections/")) {
    return;
  }
  function getUrlAdp() {
    const searchParams = new URLSearchParams(window.location.search);
    const adpParam = searchParams.get("adp");
    return adpParam ? decodeURIComponent(adpParam) : "";
  }
  const adpValue = getUrlAdp();
  if (adpValue) {
    const handles = adpValue ? adpValue.split(",") : [];
    const productList = document.querySelector(".product-list");
    if (handles.length && productList) {
      const productItems = Array.from(
        productList.querySelectorAll(".product-card")
      );

      if (productItems.length <= 1) return; // 无需重排

      const firstItem = productItems[0];
 

      // 按handles顺序收集需要前置的产品
      const preItems = handles.flatMap((handle) =>
        productItems.filter(
          (item) => item.getAttribute('handle') === handle && item !== firstItem
        )
      );

      // 从原位置移除并重新插入
      preItems.forEach((item) => {
        if (item.parentNode === productList) {
          productList.removeChild(item);
          productList.insertBefore(item, firstItem);
        }
      });
    }
  }
}

// webcomponent 继承一个 button
// 点击 判断是否有 data-variant-id
// 如果有就需要发起请求 并且把 按钮状态改成 loading
class AddToCartButton extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick.bind(this));
    const button__loader = document.createElement("div");
    this.classList.add("add-to-cart");
    button__loader.classList.add("loading-dots");
    button__loader.innerHTML = `<div class="loading-dot"></div>
            <div class="loading-dot"></div>
            <div class="loading-dot"></div>`;
    this.button__loader = button__loader;
  }
  setLoading(isLoading) {
    if (isLoading) {
      this.setAttribute("disabled", "");
      const dom = this.firstElementChild;
      if (dom) {
        dom.style.display = "none";
      }
      this.appendChild(this.button__loader);
    } else {
      this.removeAttribute("disabled");
      const dom = this.firstElementChild;
      if (dom) {
        dom.style.display = "block";
      }
      this.removeChild(this.button__loader);
    }
  }
  async handleClick() {
    const variantId = this.dataset.variantId || this.dataset.variant_id;
    if (!variantId) return;
    try {
      this.setLoading(true);
      // 这里添加你的请求逻辑
      let sectionsToBundle = ["variant-added"];
      const newFormData = new FormData();
      newFormData.append("utf8", "✓");
      newFormData.append("form_type", "product");
      newFormData.append("id", variantId);
      newFormData.append("quantity", 1);
      newFormData.set("sections", sectionsToBundle.join(","));
      newFormData.set(
        "sections_url",
        `${Shopify.routes.root}variants/${variantId}`
      );

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        body: newFormData,
      });
      const responseJson = await response.json();
      if (response.ok) {
        const cartContent = await (
          await fetch(`${Shopify.routes.root}cart.js`)
        ).json();
        cartContent["sections"] = responseJson["sections"];
        const data = cartContent.items.find(
          (item) => item.variant_id == variantId
        );
        if (data) {
          this.dispatchEvent(
            new CustomEvent("cart:add", {
              bubbles: true,
              detail: [
                {
                  id: variantId,
                  quantity: 1,
                  sku: data.sku,
                  title: data.title,
                  price: data.price,
                },
              ],
            })
          );
        }
        this.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty("items")
                ? responseJson["items"]
                : [responseJson],
              cart: cartContent,
            },
          })
        );
        if (
          window.themeVariables.settings.cartType === "page" ||
          window.themeVariables.settings.pageType === "cart"
        ) {
          return (window.location.href = `${Shopify.routes.root}cart`);
        }
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartContent,
            },
          })
        );
      } else {
        this.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"],
            },
          })
        );
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      this.setLoading(false);
    }
  }
}

customElements.define("add-to-cart", AddToCartButton, { extends: "button" });

// web components  实现一个 popover 支持 上下左右 控制 弹窗内容用 插槽
// 弹窗 为黑底 需要一个三角形箭头
class PopoverComponent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.position = this.getAttribute("position") || "bottom";
    this.isOpen = this.hasAttribute("open");

    const style = document.createElement("style");
    style.textContent = `
      :host {
        position: relative;
        display: inline-block;
        --popover-bg: #fff;
        --popover-color: #000;
      }
      .popover {
        position: absolute;
        background: var(--popover-bg);
        color: var(--popover-color);
        padding: 10px;
        border-radius: 4px;
        z-index: 1000;
        display: none;
        width: max-content;
        box-sizing: border-box;
      }
      .popover::before {
        content: '';
        position: absolute;
        border: 8px solid transparent;
      }
      .popover[data-position='top'] {
        bottom: calc(100% + 8px);
        left: 0;
        transform: none;
      }
      .popover[data-position='top']::before {
        border-top-color: var(--popover-bg);
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
      .popover[data-position='bottom'] {
        top: calc(100% + 8px);
        left: 0;
        transform: none;
      }
      .popover[data-position='bottom']::before {
        border-bottom-color: var(--popover-bg);
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
      .popover[data-position='left'] {
        right: calc(100% + 8px);
        top: 0;
        transform: none;
      }
      .popover[data-position='left']::before {
        border-left-color: var(--popover-bg);
        left: 100%;
        top: 50%;
        transform: translateY(-50%);
      }
      .popover[data-position='right'] {
        left: calc(100% + 8px);
        top: 0;
        transform: none;
      }
      .popover[data-position='right']::before {
        border-right-color: var(--popover-bg);
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
      }
    `;

    const template = document.createElement("template");
    template.innerHTML = `
      <div class="trigger">
        <slot name="trigger"></slot>
      </div>
      <div class="popover" data-position="${this.position}">
        <slot></slot>
      </div>
    `;

    this.shadowRoot.appendChild(style);
    this.shadowRoot.appendChild(template.content.cloneNode(true));

    this.triggerElement = this.shadowRoot.querySelector(".trigger");
    this.popoverElement = this.shadowRoot.querySelector(".popover");

    this.triggerElement.addEventListener("click", () => this.toggle());

    // 点击外部关闭弹窗
    document.addEventListener("click", (e) => {
      if (!this.contains(e.target) && this.isOpen) {
        this.hide();
      }
    });

    // 初始化显示状态
    if (this.isOpen) {
      this.show();
    }
  }

  toggle() {
    if (this.isOpen) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    this.popoverElement.style.display = "block";
    this.isOpen = true;
    this.setAttribute("open", "");
  }

  hide() {
    this.popoverElement.style.display = "none";
    this.isOpen = false;
    this.removeAttribute("open");
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "position" && oldValue !== newValue) {
      this.position = newValue;
      this.popoverElement.setAttribute("data-position", newValue);
    } else if (name === "open" && oldValue !== newValue) {
      if (this.hasAttribute("open")) {
        this.show();
      } else {
        this.hide();
      }
    }
  }

  static get observedAttributes() {
    return ["position", "open"];
  }
}

customElements.define("rantion-popover", PopoverComponent);
